var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.46 18C33.69 18.35 32.86 18.58 32 18.69C32.88 18.16 33.56 17.32 33.88 16.31C33.05 16.81 32.13 17.16 31.16 17.36C30.37 16.5 29.26 16 28 16C25.65 16 23.73 17.92 23.73 20.29C23.73 20.63 23.77 20.96 23.84 21.27C20.28 21.09 17.11 19.38 15 16.79C14.63 17.42 14.42 18.16 14.42 18.94C14.42 20.43 15.17 21.75 16.33 22.5C15.62 22.5 14.96 22.3 14.38 22V22.03C14.38 24.11 15.86 25.85 17.82 26.24C17.1908 26.4122 16.5301 26.4362 15.89 26.31C16.1616 27.1625 16.6936 27.9084 17.4111 28.4429C18.1285 28.9775 18.9955 29.2737 19.89 29.29C18.3737 30.4904 16.494 31.1393 14.56 31.13C14.22 31.13 13.88 31.11 13.54 31.07C15.44 32.29 17.7 33 20.12 33C28 33 32.33 26.46 32.33 20.79C32.33 20.6 32.33 20.42 32.32 20.23C33.16 19.63 33.88 18.87 34.46 18Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.91e83589e3f2619a441456ab22e8b453.svg";
export { ForwardRef as ReactComponent };